export default {
  placeholder: 'Vybrať dni v týždni',
};
